import { render, staticRenderFns } from "./MetricRegionalPlotter.vue?vue&type=template&id=d8da97c2&scoped=true&"
import script from "./MetricRegionalPlotter.vue?vue&type=script&lang=js&"
export * from "./MetricRegionalPlotter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8da97c2",
  null
  
)

export default component.exports